import { TranslateService } from "@ngx-translate/core";
import { UiUser } from "./ui-user.model";
import { DataElement } from "./common";
import { booleanObjectType } from "aws-sdk/clients/iam";
import { OrderFile } from "./order.model";
import { TaskStatusEnum } from "./agent-tasks.model";

export class ChatContact {
  contactId: string;
  name: string;
  chatTitle: string;
  messages: ChatMsg[] = [];
  lastSeen: Date;
  curDbDate: Date;
  participantsActivity: ChatParticipantActivity[] = [];

  get unreadCnt(): number {
    if (this.messages.length > 0) {
      return this.messages.filter((m) => !m.readByMe && !m.unreadDividerSw)
        .length;
    }
    return 0;
  }

  get tabTitleDescr(): string {
    let title = "";
    if (this.messages.length > 0) {
      let unread = this.messages.filter((m) => !m.readByMe);
      title = "(" + this.messages.length + ")";
      if (unread.length > 0) {
        title +=
          " " +
          unread.length +
          " " +
          this.translateService.instant("translate.chat.unreadMsgs");
      }
    }
    return title;
  }

  constructor(private translateService: TranslateService) {}
}

export class ChatMsg {
  msgId: number;
  orderId: number;
  fromType: string;
  fromUserId: number;
  fromUserDescr: string;
  fromUserType: string;
  timestamp: Date;
  msgText: string;
  seenBy: ChatSeenBy[] = [];
  readByMe: boolean;
  isMine: boolean;
  unreadDividerSw: boolean = false;
  fileId: string;
  modelType: string;
  taskId: number;
  isVideo: boolean;
  mimeType: string;
  contentType: string;
  contentUrl: string;
  contentS3Key: string;
  audioDur: number;
  audioSrc: any;
  videoSrc: any;
  file: OrderFile;

  constructor() {}
}

export class ChatSeenBy {
  userId: number;
  userDescr: string;
  userType: string;
  userRoleDescr: string;
  timestamp: Date;
  userOrg: string;

  constructor() {}
}

export class ChatParticipantActivity {
  userId: number;
  userName: string;
  lastActivityDate: Date;

  constructor() {}
}

export class SendMsgEventData {
  contact: ChatContact;
  msg: ChatMsg;
  onSuccessCallback: any;
  onErrorCallback: any;
  constructor() {}
}

export class UserNotification {
  id: number;
  type: string;
  timestamp: Date;
  text: string;
  orderId: number;
  orderIdMmd: number;
  clinicId: string;
  requireReadSw: boolean;
  readSw: boolean;
  importantSw: boolean;

  constructor() {}
}

export class ChatTask {
  taskId: number;
  msgId: number;
  msgTxt: string;
  msgTimestamp: Date;
  msgFromUserDescr: string;
  taskTitle: string;
  owner: UiUser;
  notes: string;
  dueDate: Date;
  status: DataElement;
  createUserDescr: string;
  createTimestamp: string;
  lastUpdUserDescr: string;
  lastUpdTimestamp: string;

  constructor() {}

  // ui-table greys out rows flagged rowGrey; only OPEN tasks are active
  get rowGrey(): boolean {
    return this.status?.id != TaskStatusEnum.OPEN;
  }
}

export class NotificationTypeEnum {
  static CHAT_MSG: string = "CHAT_MSG";
  static SUPPLIES_NEW_ORDER: string = "SUPPLIES_NEW_ORDER";
  static FILE_UPLOAD: string = "FILE_UPLOAD";
  static ORDER_DUE_DATE_UPD: string = "ORDER_DUE_DATE_UPD";
  static NEW_TASK: string = "NEW_TASK";
  static TASK_UPD: string = "TASK_UPD";
}
